import MagicLinkIcon from "Assets/holidays-calendar.svg";
import MicrosoftIcon from "Assets/microsofticon.svg";
import GoogleIcon from "Assets/googleicon.svg";
import OktaIcon from "Assets/icon/single-sign-on/okta@3x.png";
import { SIGN_IN_TOGGLE } from "./dataTypes";

export const getToggleIcon = (toggleId: string): string => {
  switch (toggleId) {
    case SIGN_IN_TOGGLE.GOOGLE:
      return GoogleIcon;
    case SIGN_IN_TOGGLE.MAGIC_LINK:
      return MagicLinkIcon;
    case SIGN_IN_TOGGLE.MICROSOFT:
      return MicrosoftIcon;
    case SIGN_IN_TOGGLE.OKTA:
      return OktaIcon;
  }
};
